import styled from 'styled-components';
import { animated } from 'react-spring';

const Message = styled(animated.div)`
  width: 600px;
  height: 70px;
  opacity: 0;
`;

export { Message };
